import React, { useState, useEffect, useRef } from 'react';
import { Link, Grid, TextField, FormControl, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(theme => ({
  formControl: {
    minWidth: '100%',
    marginTop: theme?.spacing(1.5),
  },
  label: {
    lineHeight: '30px',
  },
  Input: {
    '& .MuiOutlinedInput-root': {
      borderRadius: theme?.spacing(0),
    },
    '& .MuiInputBase-inputSizeSmall': {
      padding: theme?.spacing(1, 1.5),
      backgroundColor: '#fff',
    },
    '& .MuiOutlinedInput-root:hover .MuiInputBase-inputSizeSmall': {
      borderColor: '#B72755',
    },
    '& .MuiFormHelperText-marginDense': {
      margin: theme?.spacing(0.5, 0.5, 0, 0.5),
    },
  },
}));

const InlineAutoSearch = (props) => {
  const {
    name, suggestions, userInput, label, setUserInput, required, variant = 'outlined', handleInputChange, error = null, size = 'small', searchNotFound,
    placeholder, values, handleInputChangeSearch, setValues, ...others
  } = props;

  const [activeSuggestion, setActiveSuggestion] = useState(0);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const classes = useStyles();

  function useOutsideAlerter(ref) {
    useEffect(() => {
      /**
      * Alert if clicked on outside of element
      */
      function handleClickOutside(event) {
        if (ref?.current && !ref.current.contains(event.target)) {
          setShowSuggestions(false);
        }
      }
      // Bind the event listener
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, [ref]);
  }

  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef);

  const onChange = (e) => {
    setActiveSuggestion(0);
    setShowSuggestions(true);
    setUserInput(e.currentTarget?.value ?? '');
    handleInputChange('', '');
    handleInputChangeSearch ? handleInputChangeSearch(e) : '';
    setValues({
      ...values,
      [e.target?.name ?? '']: e.target?.value ?? '',
    });
  };

  const onClick = (e, paramCode, paramName) => {
    setActiveSuggestion(0);
    setShowSuggestions(false);
    handleInputChange(paramName, paramCode);
    setValues({
      ...values,
      serialNumber: '',
      productName: paramName,
      productNumber: paramCode,
    });
  };

  return (
    <div ref={wrapperRef}>
      <FormControl variant={variant} className={classes?.formControl}>
        <Grid container spacing={0}>
          <Grid item xs={12} md={4} >
            <Typography
              component="p"
              className={`${required ? 'inputLabel required' : 'inputLabel'} ${classes?.label}`}
            >{label}
            </Typography>
          </Grid>
          <Grid item xs={12} md={8} >
            <TextField
              placeholder={placeholder}
              variant="outlined"
              name={name}
              value={values[name]}
              onChange={onChange}
              onClick={() => setShowSuggestions(true)}
              type="text"
              size={size}
              InputLabelProps={{
                shrink: true,
              }}
              fullWidth
              {...others}
              {...(error && { error: 'true', helpertext: error })}
              autoComplete="off"
              className={classes?.Input}
            />
            {
              (showSuggestions && userInput) &&
              (suggestions.length ?
                <Grid container>
                  <Grid item xs={12} md={12} className="suggetions-container">
                    <ul className="suggestions">
                      {suggestions?.map((suggestion, index) => (
                        <li className={`${index === activeSuggestion ? 'suggestion-active suggetion-list' : 'suggetion-list'}`} key={index}>
                          <Link
                            onClick={e => onClick(e, suggestion?.itemNbr, suggestion?.name)}
                            fullWidth
                          >
                            {suggestion?.name}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </Grid>
                </Grid>
                :
                searchNotFound)
            }
          </Grid>
        </Grid>
      </FormControl>
    </div>
  );
};

export default InlineAutoSearch;
